import api from 'services/api.service';
import type { TFindObjectsPayload } from 'slices/object.slice';
import type { IAPIResult } from 'types/state.interface';
import type { TTEObject } from '@timeedit/types';

export const validateExtIdAvailability = async (extId: string) => {
  try {
    const res = (await api.post({
      endpoint: '/objects/find',
      data: {
        extIds: [extId],
        limit: 1,
      },
      suppressNotification: true,
    })) as IAPIResult<TTEObject>;
    return res.results.length === 0;
  } catch (e) {
    console.error(e);
    return false;
  }
};

// TODO: This can be renamed or even removed with some further work
export const findMoreObjectsForModal = async (
  body: TFindObjectsPayload
): Promise<{
  objects: TTEObject[];
  totalPages: number;
  totalResults: number;
}> => {
  try {
    const { results, totalPages, totalResults } = (await api.post({
      endpoint: '/objects/find',
      data: body,
      suppressNotification: true,
    })) as IAPIResult<TTEObject>;

    return {
      objects: results,
      totalPages,
      totalResults,
    };
  } catch (err) {
    console.error(err);
    return {
      objects: [],
      totalPages: 1,
      totalResults: 0,
    };
  }
};
